import { Flex, Title, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import { useGetRemoteMethods } from '../hooks/use-get-remote-methods';
import { useCreateRemoteMethod } from '../hooks/use-create-remote-method';
import { useUpdateRemoteMethod } from '../hooks/use-update-remote-method';
import { useDeleteRemoteMethod } from '../hooks/use-delete-remote-method';
import { RemoteMethodsTable } from './remote-methods-table';
import { RemoteMethodCreateForm } from './remote-method-create-form';
import { RemoteMethodUpdateForm } from './remote-method-update-form';

import type { TRemotePaymentMethod } from '../store/types';

type Props = {
  paymentSystemId: number;
};

export const RemotePaymentMethods = (props: Props) => {
  const { paymentSystemId } = props;

  const {
    remoteMethods,
    isLoading,
  } = useGetRemoteMethods(paymentSystemId);

  const { handleRemoteMethodCreate } = useCreateRemoteMethod();
  const { handleRemoteMethodUpdate } = useUpdateRemoteMethod();
  const { handleRemoteMethodDelete } = useDeleteRemoteMethod();

  const openCreateModal = () => modals.open({
    title: 'Создание платёжного метода',
    // centered: true,
    children: (
      <RemoteMethodCreateForm
        paymentSystemId={paymentSystemId}
        onSubmit={handleRemoteMethodCreate}
        onClose={modals.closeAll}
      />
    ),
  });

  const openEditModal = (item: TRemotePaymentMethod) => modals.open({
    title: `Редактирование метода ${item.name} с ID ${item.id}`,
    // centered: true,
    children: (
      <RemoteMethodUpdateForm
        method={item}
        onSubmit={handleRemoteMethodUpdate}
        onClose={modals.closeAll}
      />
    ),
  });

  const openDeleteModal = (item: TRemotePaymentMethod) =>
    modals.openConfirmModal({
      title: `Удаление метода с ID ${item.id}`,
      centered: true,
      children: `Вы точно хотите удалить метод "${item.name}"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: () => handleRemoteMethodDelete({ methodId: item.id }),
    });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Платёжные методы</Title>

        <Button
          variant="outline"
          size="xs"
          onClick={openCreateModal}
        >
          Создать метод
        </Button>
      </Flex>

      <RemoteMethodsTable
        remoteMethods={remoteMethods}
        isLoading={isLoading}
        openEditModal={openEditModal}
        openDeleteModal={openDeleteModal}
      />
    </>
  );
};
